import {Box, Typography} from '@mui/material';
import {styles} from './styles';

interface PaymentSummaryBoxProps {
  totalAmount: number;
  items: Array<{
    label: string;
    amount: number;
  }>;
  taxAmount?: number;
  currency?: string;
  headerText?: string;
  width?: string | number;
}

function PaymentSummaryBox({
  totalAmount,
  items,
  currency = '£',
  headerText,
  width,
}: PaymentSummaryBoxProps) {
  return (
    <Box sx={{...styles.container, width: width || styles.container.width}}>
      <Box sx={styles.contentBox}>
        <Box>
          <Typography sx={styles.headerText}>
            {headerText || 'Total to pay:'}
          </Typography>
          <Typography sx={styles.totalAmount}>
            {currency}
            {totalAmount.toFixed(2)}
          </Typography>
        </Box>
        {items.map((item, index) => (
          <Box key={index} display="flex" justifyContent="space-between">
            <Typography sx={styles.itemText}>{item.label}</Typography>
            <Typography sx={styles.itemText}>
              {currency}
              {item.amount.toFixed(2)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default PaymentSummaryBox;
